import React from 'react';
import { Redirect } from 'react-router-dom';

import SignupTemplate from '../components/common/template/SignupTemplate';
import { useSnsSignUp } from '../Hooks/useAuth';
import * as PATH from '../lib/routes/path';

const SignupSnsPage = () => {
  const {
    isError,
    logged,
    onChangeValue,
    state,
    onClickSignupButton,
    isValidateTrue,
    isLoading,
    allowMarketing,
    allowMarketingCheck,
  } = useSnsSignUp();

  if (logged) return <Redirect to={PATH.HOME} />;
  if (isError) return <Redirect to={PATH.SIGNUP} />;

  return (
    <SignupTemplate
      onChangeValue={onChangeValue}
      state={state}
      onSignup={onClickSignupButton}
      isValidateTrue={isValidateTrue}
      isLoading={isLoading}
      allowMarketing={allowMarketing}
      allowMarketingCheck={allowMarketingCheck}
      isSns
      readOnlyState={['name', 'email']}
    />
  );
};

export default SignupSnsPage;
